import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CoachSales from 'components/coachSalesPages/CoachSalesPage';
import Immutable from 'immutable';

function mapStateToProps(state, ownProps) {
  const { paymentReducer } = state;
  return {
    logo: paymentReducer.get('logo'),
    siteCheckout: paymentReducer.get('siteCheckout') || Immutable.fromJS({}),
    salesPage: paymentReducer.get('salesPage') || Immutable.fromJS({}),
    productName: paymentReducer.get('productName'),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch),
      analyticsActions: bindActionCreators(require('actions/analyticsActions'), dispatch),
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoachSales);


// WEBPACK FOOTER //
// ./src/containers/CoachSalesContainer.js